export const PXFeaturedPost = (function() {
	'use strict';

	function init() {
		events();
	}

	function events() {
		// $(window).on('load', function() {
		// 	$('.pxblock--featured-post-title').collapser({
		// 		mode: 'lines',
		// 		truncate: 3,
		// 		showText: '',
		// 		ellipsis: '...'
		// 	});
		// });
	}

	return {
		init: init
	};
})();
